import { Login } from 'Pages/Login'
import { ReminderList } from 'Components/User/ReminderList'
import { Box } from '@mui/material'
import { RecentlyCreatedDuplicates } from 'Components/DuplicateHandling/RecentlyCreatedDuplicates'
import { MyCreatedDuplicates } from 'Components/DuplicateHandling/MyCreatedDuplicates'
import { useAuth } from 'hooks/use-auth'
import { usePermissions } from 'hooks/use-permissions'
import { Role } from 'core/types'
import { MyAccessRequests } from 'Components/DuplicateHandling/MyaccessRequests'
import { WelcomeCopy, WelcomePhoto } from './LoginPage'
import mieccLogo from 'Assets/Logos/MiECC.png'

export function AboutPage (): JSX.Element {
  const { user } = useAuth()
  const perms = usePermissions()

  const hasRecentDupes = false && (perms.ISDs_DuplicateHandling || user?.securityLevel === Role.MIECC_ADMIN)
  const hasMyDupes = !perms.ISDs_DuplicateHandling && user?.securityLevel !== Role.CARE_GIVER && user?.securityLevel !== Role.MIECC_ADMIN
  const hasAccessRequests = perms.ISDs_Approvals && user?.securityLevel === Role.ISD_USER

  return <>
    <Login />
    {user != null &&
      <Box data-testid='homepage'>
        <Box sx={{ marginTop: '15px' }}>
          <ReminderList />
        </Box>
        <Box sx={{ marginTop: '15px' }}>
          { hasRecentDupes && <RecentlyCreatedDuplicates />}
          { hasMyDupes && <MyCreatedDuplicates />}
          { hasAccessRequests && <MyAccessRequests />}
          {!(hasRecentDupes || hasMyDupes || hasAccessRequests) && (<>
            <Box>
              <Box sx={{ pt: 8, px: 6, pb: 4, textAlign: 'center' }}>
                <Box component="img" src={mieccLogo} alt="MiEarly Childhood Connect" sx={{ width: '100%', maxWidth: '320px', mb: 3, mx: 'auto' }} />
                <WelcomeCopy headingVariant="h5" loggedIn />
              </Box>
              {/* Centered on the same axis as the logo/copy above. WelcomePhoto is a fixed 16:9 band, so
                  capping its width also caps its height: ~520px covers the header, logo, welcome copy
                  and footer, leaving the photo whatever vertical space remains (up to 1200px wide) so the
                  page doesn't scroll. The 320px floor keeps it from collapsing on very short screens. */}
              <Box sx={{ width: '100%', maxWidth: 'clamp(320px, calc((100vh - 520px) * 16 / 9), 1200px)', mx: 'auto' }}>
                <WelcomePhoto />
              </Box>
            </Box></>
          )}
        </Box>
      </Box>
    }
  </>
}
